<template>
  <div class="superheading" v-if="loadedSections.length > 0">
    <!-- @@@ this will expose the english title, which may or may not be desirable  <h4>{{ superheading.title }}</h4> -->
    <LoadMore
      v-if="hasPrev && !prevLoading"
      @fetch="loadPrevious"
      :key="`${prev}-prev`">
    </LoadMore>
    <LoaderBall style="margin:10px auto; height: 36px;" v-else-if="hasPrev && prevLoading" />

    <Section
      v-for="section in loadedSections"
      :key="section.idx"
      :selected-section="selectedSection"
      :selected-line="selectedLine"
      :selected-token="selectedToken"
      :work="work"
      :section="section"
      :alignments-map="alignmentsMap"
      :reader-id="readerId"
      @scrollToElement="element => $emit('scrollToElement', element)"
    />

    <LoaderBall
      v-observe-visibility="{callback: shouldLoadNext, once: true, throttle: 300, throttleOptions: {leading: 'visible'}, intersection: {rootMargin: '200%'}}"
      v-if="hasNext && !nextLoading"
      :key="`${next}-next`">
    </LoaderBall>
    <LoaderBall v-else-if="hasNext && nextLoading" />
  </div>
  <LoaderBall v-else />
</template>

<script>
  import Section from './Section/Section.vue';
  import LoaderBall from './LoaderBall.vue';
  import LoadMore from './LoadMore.vue';

  export default {
    components: {
      Section,
      LoadMore,
      LoaderBall,
    },
    props: ['work', 'pivotIdx', 'sectionsPager', 'selectedSection', 'selectedLine', 'readerId', 'selectedToken', 'alignmentsMap', 'sections'],
    data() {
      return {
        nextLoading: false,
        prevLoading: false,
      };
    },
    watch: {
      prev() {
        this.prevLoading = false;
      },
      next() {
        this.nextLoading = false;
      },
    },
    computed: {
      hasPrev() {
        return Number.isInteger(this.sectionsPager.prev);
      },
      prev() {
        return this.sectionsPager.prev;
      },
      hasNext() {
        return Number.isInteger(this.sectionsPager.next);
      },
      next() {
        return this.sectionsPager.next;
      },
      loadedSections() {
        return this.sections;
      },
    },
    methods: {
      loadPrevious() {
        this.prevLoading = true;
        this.$emit('paginate', { sectionIdx: this.prev, scrollingUp: true });
      },
      loadNext() {
        this.nextLoading = true;
        this.$emit('paginate', { sectionIdx: this.next });
      },
      shouldLoadPrevious(isVisible) {
        if (isVisible) {
          this.loadPrevious();
        }
      },
      shouldLoadNext(isVisible) {
        if (isVisible) {
          this.loadNext();
        }
      },
    },
  };
</script>


<style lang="scss">
  @import "../variables.scss";

  .text {
    &.text-reuse .token-match {
      color: black;
    }
  }

  .superheading-loading {
    min-height: 500px;
  }

  .superheading span {
      &.person-0 { border-bottom: 3px solid $entity-color-1; }
      &.person-1 { border-bottom: 3px solid $entity-color-2; }
      &.person-2 { border-bottom: 3px solid $entity-color-3; }
      &.person-3 { border-bottom: 3px solid $entity-color-4; }
      &.person-4 { border-bottom: 3px solid $entity-color-5; }

      &.place-0 { border-bottom: 3px solid $entity-color-6; }
      &.place-1 { border-bottom: 3px solid $entity-color-7; }
      &.place-2 { border-bottom: 3px solid $entity-color-8; }
      &.place-3 { border-bottom: 3px solid $entity-color-9; }
      &.place-4 { border-bottom: 3px solid $entity-color-11; }
      &.event-1 { border-bottom: 3px solid $entity-color-12; }
      &.event-2 { border-bottom: 3px solid $entity-color-13; }
      &.event-3 { border-bottom: 3px solid $entity-color-14; }
      &.event-4 { border-bottom: 3px solid $entity-color-15; }
  }
  .previous-scroll-control {
    margin-top: 10px;
    text-align: center;
    color: $primary;
  }
</style>
